module.exports = __webpack_public_path__ + "img/suffocated_zombie_small.ddeaae4b.png";